import { apiRequest, readJsonOrThrow } from "@/api/client";

export async function fetchAffiliateDashboard(session) {
  const response = await apiRequest("/momo/affiliates/me", {
    session,
    includeContentType: false,
  });
  return readJsonOrThrow(response, "Failed to load affiliate dashboard");
}

export async function enrollAffiliate(session) {
  const response = await apiRequest("/momo/affiliates/enroll", {
    method: "POST",
    session,
    body: { terms_accepted: true },
  });
  return readJsonOrThrow(response, "Failed to enroll in affiliate program");
}

export async function updateAffiliateCode(session, code) {
  const response = await apiRequest("/momo/affiliates/me/code", {
    method: "PATCH",
    session,
    body: { code },
  });
  return readJsonOrThrow(response, "Failed to update affiliate code");
}

export async function requestAffiliatePayout(session) {
  const response = await apiRequest("/momo/affiliates/payouts", {
    method: "POST",
    session,
    body: {},
  });
  return readJsonOrThrow(response, "Failed to request affiliate payout");
}
